import H from 'constants/httpMethod.const';
import UMSG_TYPE from 'constants/umsg/type.const';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

// Response body / bodies
// SEE: https://getslick.atlassian.net/browse/GS-16053?focusedCommentId=28539
// ({
//   "results": {
//     "verification_link": "<URL to stripe verification page>",
//     "success_code": "<success code string>",
//     "message": "<success message string>"
//   },
//   "errors": {
//     "error_code": "<error code string>",
//     "message": "<error message string>"
//   },
// })

const fromDtoToVerifyResponse = (dto) => {
  const successCode = dto?.results?.success_code;
  const errorCode = dto?.errors?.error_code;
  const successMessage = dto?.results?.message;
  const errorMessage = dto?.errors?.message;

  return {
    //
    // computed fields
    isError: fromAnyToBool(dto?.errors),
    code: successCode ?? errorCode,
    message: successMessage ?? errorMessage,
    //
    // plainly mapped fields
    verificationLink: dto?.results?.verification_link,
    successCode,
    errorCode,
    successMessage,
    errorMessage,
  };
};

export const beVerifyStripeIdentityWrite = actionEndpointBe('beVerifyStripeIdentityWrite', H.post, 'settings/verify/salon/identity/stripe/:salonId/', (options) => ({
  ...options,
  inert: true,
  isMissingParams: false,
  umsg: UMSG_TYPE.global,
  fromDto: fromDtoToVerifyResponse,
}));

export const beVerifyStripeIdentityToggle = actionEndpointBe('beVerifyStripeIdentityToggle', H.post, 'salon/v3/:salonId/experiemental/switch/stripe/restriction/', (options) => ({
  ...options,
  inert: true,
  isMissingParams: false,
  umsg: UMSG_TYPE.global,
}));
